<template>
  <v-row>
    <v-col cols="12">
      <app-card heading="Launch WHM">
        <gg-btn color="success" tile @click="launch_whm(hostingid)">Launch WHM</gg-btn>
      </app-card>
    </v-col>
  </v-row>
</template>

<script>
import { launch_whm } from '@/helpers/helpers'

export default {
  name: 'DServerWHM',
  props: {
    hostingid: {
      type: String,
      required: true
    }
  },
  methods: {
    launch_whm
  }
}
</script>
